import { validateProducts, validateFilters, validateSearchMeta, validateSortOptions } from '../utils/validation';
export function mapProducts(products) {
    const mappedProducts = products.map((product, index) => {
        var _a, _b;
        const price = product.price_max | 0;
        const compareAtPrice = product.compare_at_price_max ? product.compare_at_price_max : 0;
        const data = {
            id: String(product.id),
            title: product.title,
            handle: product.handle,
            brand: product.vendor,
            color: '',
            size: [
                ''
            ],
            price: {
                regular: price >= compareAtPrice ? price : compareAtPrice,
                sale: price >= compareAtPrice ? undefined : price,
                special: undefined
            },
            image: {
                url: product.images_info && ((_a = product.images_info[0]) === null || _a === void 0 ? void 0 : _a.src) || '',
                alt: product.images_info && ((_b = product.images_info[0]) === null || _b === void 0 ? void 0 : _b.alt) || `${product.title}-image`,
            },
            availability: product.available ? 'in_stock' : 'out_of_stock',
        };
        return data;
    });
    return validateProducts(mappedProducts, 'Boost');
}
export function mapFilters(filter, currentFilters) {
    const filters = [];
    if (!filter || !filter.options) {
        console.warn('[Boost Mapper] No filter or filter.options provided');
        return filters;
    }
    filter.options.map(option => {
        const filter = {
            id: option.filterOptionId,
            label: option.label,
            type: 'select',
            options: []
        };
        if (option.displayType === 'list' && Array.isArray(option.values)) {
            filter.type = 'select';
            filter.options = option.values.map((value) => {
                var _a;
                return {
                    id: String(value.key),
                    label: String(value.key),
                    count: Number(value.doc_count),
                    selected: ((_a = currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters[option.filterOptionId]) === null || _a === void 0 ? void 0 : _a.includes(String(value.key))) || false,
                    value: String(value.key)
                };
            });
        }
        if (option.displayType === 'range') {
            filter.type = 'range';
            const rangeValues = option.values;
            if (option.filterType === 'price' && (currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.pf_p_price)) {
                filter.currentMin = Number(currentFilters.pf_p_price[0].split(":")[0]);
                filter.currentMax = Number(currentFilters.pf_p_price[0].split(":")[1]);
            }
            else {
                filter.currentMin = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.min;
                filter.currentMax = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.max;
            }
            filter.min = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.min;
            filter.max = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.max;
        }
        filters.push(filter);
    });
    return validateFilters(filters, 'Boost');
}
export function mapMeta(data, page, pageSize) {
    return validateSearchMeta({
        totalResults: data.total_product,
        totalPages: Math.ceil(data.total_product / pageSize),
        currentPage: page,
        pageSize
    }, 'Boost');
}
export function mapSorts() {
    return validateSortOptions([
        { id: 'relevance', label: 'Relevance' },
        { id: 'price_asc', label: 'Price: Low to High' },
        { id: 'price_desc', label: 'Price: High to Low' },
        { id: 'title_asc', label: 'Name: A to Z' },
        { id: 'title_desc', label: 'Name: Z to A' },
    ], 'Boost');
}
